import apicaller from "../../../utils/apicaller";
import api from "../../../main.api";
import constant from "../../../main.constants";
import commonFunc from "../../../common.func";

const actions = {
    clearRouteHistory(context) {
        context.commit("clearRouteHistory");
    },
    // ŞİB Takibi kalan gün sayısı: yetkisi olan kullanıcı için tek seferlik çekilir.
    // Router interceptor'dan (sayfa değişimi / ilk açılış) tetiklenir.
    fetchSibTrackingRemainingDay({ commit }) {
        if (!commonFunc.checkPermissionWithName(constant.PERMISSIONS.sibTrackingUser)) {
            return;
        }
        apicaller
            .get(api.SIBTRACKING.getSibTrackingRemainingDay)
            .then((resp) => {
                if (resp.data && resp.data.statusCode == 200) {
                    commit("setSibTrackingRemainingDay", resp.data.result);
                }
            })
            .catch((ex) => {
                console.log("fetchSibTrackingRemainingDay hata:", ex);
            });
    },
    addRouteToHistory({ commit, state }, { route }) {
        if (state.routeHistory.length > 0
            && state.routeHistory[state.routeHistory.length - 1] == route) {
            return;
        }
        commit('addRouteToHistory', route);
    },
    goToPreviousRoute({ commit, state }, { router }) {
        if (state.routeHistory.length > 1) {
            commit('goToPreviousRoute');
            router.push(state.routeHistory[state.routeHistory.length - 1]);
        }
    },
    setLoadedEntityWithAttrs(context) {
        context.commit("setLoadedEntityWithAttrs");
    },
}

export default actions;